(function () {
  'use strict';
  var configElement = document.getElementById('fd-drop-notify-config');
  var pop = document.getElementById('notify-pop');
  if (!configElement || !pop || window.FDLaunchNotify) return;
  var config = JSON.parse(configElement.textContent);
  var forms = Array.from(document.querySelectorAll('[data-fd-launch-form]'));
  var storageKey = 'fd-launch-notify-v1-' + config.listId;
  var joined = false;
  var pending = false;
  var anchor = null;
  try { joined = localStorage.getItem(storageKey) === 'joined'; } catch (_) {}
  document.body.appendChild(pop);

  function renderForms(message) {
    forms.forEach(function (form) {
      form.querySelector('.fd-launch-fields').hidden = joined;
      var status = form.querySelector('.fd-launch-status');
      status.hidden = !joined;
      status.textContent = joined ? (message || config.already) : '';
      var button = form.querySelector('button[type="submit"]');
      button.disabled = pending;
      button.textContent = pending ? config.saving : config.submit;
      form.setAttribute('aria-busy', String(pending));
      if (joined) form.querySelector('.fd-launch-error').hidden = true;
    });
  }

  function place() {
    if (!anchor || pop.hidden) return;
    var rect = anchor.getBoundingClientRect();
    var width = pop.offsetWidth;
    var viewportWidth = document.documentElement.clientWidth;
    var left = Math.max(12, Math.min(rect.left + rect.width / 2 - width / 2, viewportWidth - width - 12));
    var top = rect.bottom + 8;
    var bar = document.getElementById('gb-bar');
    var bottomLimit = window.innerHeight - 12;
    if (bar && getComputedStyle(bar).position === 'fixed') bottomLimit = Math.min(bottomLimit, bar.getBoundingClientRect().top - 8);
    if (top + pop.offsetHeight > bottomLimit) top = rect.top - pop.offsetHeight - 8;
    top = Math.max(12, Math.min(top, bottomLimit - pop.offsetHeight));
    pop.style.top = (window.scrollY + top) + 'px';
    pop.style.left = (window.scrollX + left) + 'px';
  }

  function close() {
    pop.hidden = true;
    if (anchor) anchor.focus({ preventScroll: true });
    anchor = null;
  }

  function open(trigger) {
    anchor = trigger;
    renderForms(config.already);
    pop.hidden = false;
    place();
    if (joined) document.getElementById('notify-pop-close').focus({ preventScroll: true });
    else pop.querySelector('input[type="email"]').focus({ preventScroll: true });
  }

  function markJoined() {
    joined = true;
    try { localStorage.setItem(storageKey, 'joined'); } catch (_) {}
    forms.forEach(function (form) { form.querySelector('input[type="email"]').value = ''; });
    renderForms(config.success);
    place();
  }

  function subscribe(address) {
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(config.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: {
          custom_source: 'FidgetDrifter new-drop alerts signup',
          profile: { data: { type: 'profile', attributes: {
            email: address,
            properties: { 'Launch Notify Scope': 'All new colors and models', 'Launch Notify Signup': true },
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: config.listId } } }
      } })
    }).then(function (response) {
      if (!response.ok) throw new Error('Signup not accepted');
    });
  }

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (joined) { renderForms(config.already); return; }
      if (pending || !form.reportValidity()) return;
      var address = form.querySelector('input[type="email"]').value.trim();
      if (!address) return;
      form.querySelector('.fd-launch-error').hidden = true;
      pending = true;
      renderForms();
      subscribe(address).then(markJoined).catch(function () {
        var error = form.querySelector('.fd-launch-error');
        error.textContent = config.error;
        error.hidden = false;
      }).finally(function () {
        pending = false;
        renderForms(joined ? config.success : undefined);
        place();
      });
    });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-notify-stock]');
    if (trigger) {
      if (event.target.closest('.fd-card-photo')) return;
      var button = trigger.matches('button') ? trigger : trigger.querySelector('button[data-notify-stock]');
      if (button) { event.preventDefault(); open(button); }
      return;
    }
    if (!pop.hidden && !pop.contains(event.target)) close();
  });
  document.getElementById('notify-pop-close').addEventListener('click', close);
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !pop.hidden) close(); });
  window.addEventListener('resize', place);
  window.addEventListener('scroll', place, { passive: true });
  window.addEventListener('storage', function (event) {
    if (event.key !== storageKey) return;
    joined = event.newValue === 'joined';
    renderForms();
  });
  renderForms();
  window.FDNotify = { open: open, close: close, toggle: open };
  window.FDLaunchNotify = { isJoined: function () { return joined; } };
})();
